import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router";
import { push } from "react-router-redux";

import { LocationCard } from "@travellocal/ui";
import { GoogleAnalyticsHelper } from "@travellocal/ui";
import { MatchState } from "../../../../shared/helpers/reduxHelpers";
import * as WebRoutes from "@travellocal/utils/webRoutes";
import { MapWrapper } from "./../../../../shared/organisms/mapboxMap";

interface StateProps {
  regionState: IState<IRegion>;
  regionCountriesState: IState<ICountrySummary[]>;
  contentState: IKeyedState<IPagerState<IContent>>;
}

interface DispatchProps {
  navigateToPath: (path: string) => void;
}

type Props = StateProps & DispatchProps;

export class RegionOverviewComponent extends React.Component<Props> {

  public render() {
    const { regionState, regionCountriesState } = this.props;

    return (
      <div className="region-overview">
        {MatchState(regionState, {
          data: region => [

            MatchState(regionCountriesState, {
              data: regionCountries => {
                const liveCountries = regionCountries.filter(x => x.locationStatus === LocationStatus.Live);
                if (!liveCountries.length) {
                  return;
                }

                return (
                  <div className="width-wrapper card-section">
                    <h2>Countries we serve in {region.name}</h2>
                    <p className="note">Choose a country to see trip ideas from our local experts there!</p>
                    <div className="columns is-multiline is-paddingless">
                      {liveCountries.map(country =>
                        <div className={"column is-4 is-3-desktop"} key={`region-country-${country.id}`}>
                          <LocationCard
                            location={country}
                            onClick={() => GoogleAnalyticsHelper.logEvent("Select Country", "Click", "Region page card")}
                          />
                        </div>,
                      )}
                    </div>
                  </div>
                );
              },
            }),

            <div className="p-top-medium p-bottom-medium width-wrapper " key="region-country-main">
              <div className="columns">
                <div className="column is-9-tablet blog-post"
                  dangerouslySetInnerHTML={{
                    __html: region.introContent.content.html,
                  }}
                />
                <div className="column is-3-tablet">
                  <div className="blog-post">
                    {region.whenToGo &&
                      <div className="when-to-go">
                        <h3>When to go</h3>
                        <div style={{ whiteSpace: "pre-wrap" }} dangerouslySetInnerHTML={{ __html: region.whenToGo }} />
                      </div>
                    }
                    <Link className="read-more-link" to={WebRoutes.aboutHowItWorks()}>How does TravelLocal work?</Link>
                    <Link className="read-more-link" to={WebRoutes.aboutLocalExperts()}>Why should I use TravelLocal?</Link>
                  </div>
                </div>
              </div>
            </div>,

            <MapWrapper
              key="region-country-map"
              markerLocation={region.geoLocation} readonly={true} zoomLevel={region.geoLocation.zoomLevel} />,
          ],
        })}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    navigateToPath: (path: string) => dispatch(push(path)),
  };
};

const mapStateToProps = (state: IWebStoreState): StateProps => {
  return {
    regionState: state.region,
    regionCountriesState: state.regionCountries,
    contentState: state.contentByCollection,
  };
};

export const RegionOverview = connect(mapStateToProps, mapDispatchToProps)(RegionOverviewComponent);
